module.exports = __webpack_public_path__ + "static/media/sem_dados.adca9001.jpg";